function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagIR(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURdoNGfz8/DW1Ui+oSvT09N0WIe6Nkut5gJXQo4TJlJbRo+BCS/HBw/G8v10P3zsAAAEWSURBVDjL1Y2xTsMwEIb/oc6GFEveYKjIC0TxAhuWTBYWLy4zC7xA+g7lUdgYsvXluP/SRKKoVocKwZfz3e+7/xzcllnjXxi6Mi2ahtU3J2jhOy80/gRrzONuNjUUHStbLXyZcwz3H6UQw92uFHzhvRQtbJn69w2DtS/HBmeDs8xy+it7Uy13K6qGC06IzMFdj9thH21QYpRTI8QQHW9OyuOA1ZYyckk+9wBJQaXM49OI1V5uXNC1IAZFeix9harSF7hEZsPMJzB+axwb+rSJRcMPLmHIz2+lSMib11KkM14ocylDytnkg9DMm1GRYJCQDKFIyTBJMVkFYMxhOhWVnGPqYCZNklm3xEWhrWVGwR8tawl/gy9otgdg5P49YQAAAABJRU5ErkJggg==",
    alt: "IR"
  }, props));
}